module.exports = __webpack_public_path__ + "3a9710ed5c696630202ba4be92b538bb.svg";